"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const pulldown_button_1 = __importDefault(require("./pulldown.button"));
const pulldown_menu_1 = __importDefault(require("./pulldown.menu"));
class Pulldown extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            expanded: false
        };
        this.toggle = () => {
            this.setState({
                expanded: !this.state.expanded
            });
        };
        this.collapse = () => {
            this.setState({
                expanded: false
            });
        };
        this.handleClick = () => {
            if (!this.props.disabled) {
                this.toggle();
            }
        };
        this.componentDidUpdate = () => {
            if (this.props.disabled && this.state.expanded)
                this.collapse();
        };
        this.render = () => {
            const { children, buttonLabel, primary, secondary, warning, disabled } = this.props;
            const { expanded } = this.state;
            const buttonProps = {
                buttonRef: el => {
                    this.button = el;
                },
                onClick: this.handleClick,
                expanded,
                primary,
                secondary,
                warning,
                disabled
            };
            const menuProps = {
                buttonElement: this.button,
                handleCollapse: this.collapse
            };
            return (jsx_runtime_1.jsxs(react_1.default.Fragment, { children: [jsx_runtime_1.jsx(pulldown_button_1.default, Object.assign({}, buttonProps, { children: buttonLabel }), void 0),
                    expanded && jsx_runtime_1.jsx(pulldown_menu_1.default, Object.assign({}, menuProps, { children: children }), void 0)] }, void 0));
        };
    }
}
Pulldown.propTypes = {
    children: prop_types_1.default.node.isRequired,
    buttonLabel: prop_types_1.default.node.isRequired,
    primary: prop_types_1.default.bool,
    secondary: prop_types_1.default.bool,
    warning: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool
};
Pulldown.defaultProps = {
    primary: false,
    secondary: false,
    warning: false,
    disabled: false
};
exports.default = Pulldown;
//# sourceMappingURL=pulldown.js.map